/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_SyncInputs */



/**
* | output |
* | --- |
* | "One round at a time" |
*
* @param {Tournament_Wiz_Kind_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_sync = /** @type {((inputs?: Tournament_Wiz_Kind_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une ronde à la fois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una ronda cada vez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma rodada por vez")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un round alla volta")
	return /** @type {LocalizedString} */ ("One round at a time")
});